import React from "react";
import { Link, useLocation } from "react-router-dom";

function Sidebar() {
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userRole = userData.user?.role?.toLowerCase();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <aside className="w-72 bg-white/60 backdrop-blur-md shadow-soft border-r border-gray-100 min-h-screen">
      <nav className="p-6">
        <ul className="space-y-2">
          <li>
            <Link
              to="/dashboard"
              className={`flex items-center px-4 py-3.5 rounded-xl transition-all duration-200 font-medium ${
                isActive("/dashboard")
                  ? "bg-gradient-to-r from-emerald-500 to-emerald-600 text-white shadow-md"
                  : "text-gray-700 hover:bg-gray-50 hover:text-emerald-600"
              }`}
            >
              <svg
                className={`w-5 h-5 mr-3 ${isActive("/dashboard") ? "text-white" : "text-gray-400"}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              Dashboard
            </Link>
          </li>
          {userRole === "admin" && (
            <li>
              <Link
                to="/teams"
                className={`flex items-center px-4 py-3.5 rounded-xl transition-all duration-200 font-medium ${
                  isActive("/teams")
                    ? "bg-gradient-to-r from-emerald-500 to-emerald-600 text-white shadow-md"
                    : "text-gray-700 hover:bg-gray-50 hover:text-emerald-600"
                }`}
              >
                <svg
                  className={`w-5 h-5 mr-3 ${isActive("/teams") ? "text-white" : "text-gray-400"}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
                Team Management
              </Link>
            </li>
          )}
          {["admin", "advisor", "ops"].includes(userRole) && (
            <li>
              <Link
                to="/integrations"
                className={`flex items-center px-4 py-3.5 rounded-xl transition-all duration-200 font-medium ${
                  isActive("/integrations")
                    ? "bg-gradient-to-r from-emerald-500 to-emerald-600 text-white shadow-md"
                    : "text-gray-700 hover:bg-gray-50 hover:text-emerald-600"
                }`}
              >
                <svg
                  className={`w-5 h-5 mr-3 ${isActive("/integrations") ? "text-white" : "text-gray-400"}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V4z"
                  />
                </svg>
                Integrations
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar;
